import React, { useEffect } from "react";
import {
  Button,
  Divider,
  Row,
  Typography,
} from "../utils/antd-imports/AntdImports";
import "./ChatCommunication.css";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirst } from "../utils/Utils";
import ChatAndActivitySegment from "../chat-activity-tab/ChatAndActivityTabs";
import ChatTerms from "../chat-terms/ChatTerms";
import { ReactComponent as ArrowSquare } from "../../../assests/arrow-square-out.svg";
import CampaignChatList from "../seller-chat-components/CampaignsChatList";
import { setAllowChat } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";

const SellerChatCommunication = () => {
  const { Text } = Typography;

  const { allowChat } = useSelector(
    (state) => state.chatCommunicationHandleSlice
  );
  const { userType, chatsMonitered, professionalGuidelines } = useSelector(
    (state) => state.userprofile
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (chatsMonitered === true && professionalGuidelines === true) {
      dispatch(setAllowChat(true));
    } else {
      dispatch(setAllowChat(false));
    }
  }, [chatsMonitered, professionalGuidelines, dispatch]);

  return (
    <div className="chat-communication-container">
      <div>{allowChat ? <CampaignChatList /> : <ChatTerms />}</div>
    </div>
  );
};
export default SellerChatCommunication;
